/**
 * API клиент для согласования воронок (approval page).
 * 
 * Эти endpoints публичные и не требуют X-API-Key.
 */
import axios from 'axios';

const API_BASE_URL = '/api';

const approvalClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

/**
 * Получить данные для страницы согласования
 */
export async function getApprovalData(token) {
  const response = await approvalClient.get(`/approval/${token}/`);
  return response.data;
}

/**
 * Отправить решения по согласованию
 */
export async function submitApprovalDecisions(token, decisions) {
  const response = await approvalClient.post(`/approval/${token}/decide/`, { decisions });
  return response.data;
}

/**
 * Статус планирования постов в VK
 */
export async function getScheduleStatus(token) {
  const response = await approvalClient.get(`/approval/${token}/schedule-status/`);
  return response.data;
}

export default approvalClient;
